jQuery(function ($) {
  $(window).on('load resize', function () {

    $('.c-boxList').each(function () {
      const $items = $(this).find('.js-height');

      $items.css('height', 'auto');

      if ($(window).width() > 414) {
        let highest = 0;

        $items.each(function () {
          const h = $(this).outerHeight();
          if (h > highest) {
            highest = h;
          }
        });

        $items.height(highest);
      }
    });

  });
});